import { QueryClient } from '@tanstack/react-query';

// TSS vite/03 §"TanStack Query is the standard".
// Single QueryClient instance, mounted as the 3rd provider layer in app.jsx.

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: 0,
        },
    },
});
